var InitiateDcaComponent_1;
import { __decorate } from "tslib";
import { ChangeDetectorRef, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { DatePipe, LocationStrategy } from '@angular/common';
import { WebsiteThemeService } from '../../../services/website-theme.service';
import { ComponentService } from '../../../services/component.service';
import { CompleteDcaComponent } from '../complete-dca/complete-dca.component';
import { TranslateObjectPipe } from '../../../pipes/translate-object.pipe';
import { WebClientService } from '../../../services/webclient-settings.service';
import { AuthenticationWalletModalComponent } from "../authentication-wallet-modal/authentication-wallet-modal.component";
let InitiateDcaComponent = InitiateDcaComponent_1 = class InitiateDcaComponent {
    constructor(sanitizer, location, themeService, change, datePipe, translateObjectPipe, compService, webSettingsService) {
        this.sanitizer = sanitizer;
        this.location = location;
        this.themeService = themeService;
        this.change = change;
        this.datePipe = datePipe;
        this.translateObjectPipe = translateObjectPipe;
        this.compService = compService;
        this.webSettingsService = webSettingsService;
        this.errorColor = '';
        this.borderRadiusSmaller = '';
        this.borderRadiusLarger = '';
        this.activeCurrency = localStorage.getItem('defaultCurrency').toLowerCase();
        this.amounts = [5000, 10000, 15000];
        this.manualAmount = this.selectedAmount;
        this.startDate = '';
        this.currentDate = new Date();
        this.selectedDate = null;
        this.frequencyExpanded = false;
        this.frequencyOptions = [
            { key: 'WALLET.INITIALIZE_DCA.FREQUENCY_WEEKLY', value: 'weekly' },
            { key: 'WALLET.INITIALIZE_DCA.FREQUENCY_MONTHLY', value: 'monthly' },
            { key: 'WALLET.INITIALIZE_DCA.FREQUENCY_BIMONTHLY', value: 'bimonthly' },
            { key: 'WALLET.INITIALIZE_DCA.FREQUENCY_QUARTERLY', value: 'quarterly' }
        ];
        this.daysOfWeekExpanded = false;
        this.daysOfWeekOptions = [
            { key: 'WALLET.INITIALIZE_DCA.DAY_OF_WEEK_MONDAY', value: 'Monday' },
            { key: 'WALLET.INITIALIZE_DCA.DAY_OF_WEEK_TUESDAY', value: 'Tuesday' },
            { key: 'WALLET.INITIALIZE_DCA.DAY_OF_WEEK_WEDNESDAY', value: 'Wednesday' },
            { key: 'WALLET.INITIALIZE_DCA.DAY_OF_WEEK_THURSDAY', value: 'Thursday' },
            { key: 'WALLET.INITIALIZE_DCA.DAY_OF_WEEK_FRIDAY', value: 'Friday' },
            { key: 'WALLET.INITIALIZE_DCA.DAY_OF_WEEK_SATURDAY', value: 'Saturday' },
            { key: 'WALLET.INITIALIZE_DCA.DAY_OF_WEEK_SUNDAY', value: 'Sunday' }
        ];
        this.daysOfMonthExpanded = false;
        this.secondDaysOfMonthExpanded = false;
        this.daysOfMonthOptions = Array.from({ length: 31 }, (_, i) => (i + 1).toString());
        this.daysOfMonthOptionsFirstHalf = Array.from({ length: 15 }, (_, i) => (i + 1).toString());
        this.daysOfMonthOptionsSecondHalf = Array.from({ length: 16 }, (_, i) => (i + 16).toString());
        this.nextButtonDisabled = true;
        this.minAmount = '';
        this.currency = '';
        this.currenciesExpanded = false;
        this.errorColor = this.themeService.getStyleAttribute('error_color');
        this.borderRadiusSmaller = this.themeService.getStyleAttribute('border_radius_smaller');
        this.borderRadiusLarger = this.themeService.getStyleAttribute('border_radius_larger');
        location.onPopState(() => {
            this.close();
        });
    }
    ngOnInit() {
        this.startDate = this.datePipe.transform(new Date(), 'yyyy-MM-dd HH:mm:ss');
        this.webSettingsService.getSettings().subscribe(data => {
            this.minAmount = this.webSettingsService.getWebSetting('WALLET.DCA.MIN_AMOUNT');
        });
        if (this.data.dcaData) {
            this.setFields(this.data.dcaData);
            this.validateForm();
        }
        if (this.data.currency) {
            this.currency = this.data.currency;
        }
    }
    close() {
        this.modal.destroy();
    }
    setAmount(amount) {
        this.selectedAmount = amount;
        this.manualAmount = amount;
        this.validateForm();
    }
    expandFrequency() {
        this.frequencyExpanded = !this.frequencyExpanded;
    }
    fillFrequency(frequencyObj) {
        this.frequency = this.translateObjectPipe.transform(frequencyObj.key);
        this.frequencyValue = frequencyObj.value;
        if (this.frequencyValue === 'monthly') {
            this.daysOfMonthOptions = Array.from({ length: 31 }, (_, i) => (i + 1).toString());
        }
        else if (this.frequencyValue === 'bimonthly') {
            this.daysOfMonthOptions = this.daysOfMonthOptionsFirstHalf;
        }
        this.resetFields();
        this.validateForm();
    }
    expandDaysOfWeek() {
        this.daysOfWeekExpanded = !this.daysOfWeekExpanded;
    }
    fillDayOfWeek(dayObj) {
        this.dayOfWeek = this.translateObjectPipe.transform(dayObj.key);
        this.dayOfWeekValue = dayObj.value;
        this.validateForm();
    }
    onDateChange(event) {
        this.selectedDate = event.value;
        this.startDate = this.datePipe.transform(this.selectedDate, 'yyyy-MM-dd HH:mm:ss');
        this.validateForm();
    }
    expandDaysOfMonth() {
        this.daysOfMonthExpanded = !this.daysOfMonthExpanded;
    }
    expandSecondDaysOfMonth() {
        this.secondDaysOfMonthExpanded = !this.secondDaysOfMonthExpanded;
    }
    fillDayOfMonth(value) {
        this.dayOfMonth = value;
        this.validateForm();
    }
    fillSecondDayOfMonth(value) {
        this.secondDayOfMonth = value;
        this.validateForm();
    }
    validateForm() {
        this.nextButtonDisabled = true;
        if (this.frequencyValue && this.manualAmount >= Number(this.minAmount) && this.startDate) {
            switch (this.frequencyValue) {
                case 'weekly':
                    this.nextButtonDisabled = !this.dayOfWeekValue;
                    break;
                case 'monthly':
                    this.nextButtonDisabled = !this.dayOfMonth;
                    break;
                case 'bimonthly':
                    this.nextButtonDisabled = !(this.dayOfMonth && this.secondDayOfMonth);
                    break;
                case 'quarterly':
                    this.nextButtonDisabled = false;
                    break;
            }
        }
        return this.nextButtonDisabled;
    }
    goToNextStep() {
        if (!this.validateForm()) {
            this.buildDcaData();
            this.close();
            this.compService.openModal(CompleteDcaComponent, {
                dcaData: this.dcaData,
                currency: this.currency
            }, (success) => {
                if (this.data.path === 'wallet') {
                    this.success();
                }
                else {
                    this.compService.openModal(AuthenticationWalletModalComponent, {
                        authenticated: true,
                        type: 'dca',
                        isSuccess: true,
                    });
                }
            }, (data) => {
                this.compService.openModal(InitiateDcaComponent_1, Object.assign(Object.assign({}, this.data), { dcaData: this.dcaData, currency: this.currency }));
            });
        }
    }
    resetFields() {
        this.dayOfWeekValue = '';
        this.dayOfMonth = '';
        this.secondDayOfMonth = '';
        this.selectedDate = null;
    }
    buildDcaData() {
        const baseData = {
            amount: this.manualAmount.toString(),
            currency: this.currency['verboseId'],
            startDate: this.startDate,
            frequency: this.frequencyValue
        };
        switch (this.frequencyValue) {
            case 'weekly':
                baseData.dayOfWeek = this.dayOfWeekValue;
                break;
            case 'monthly':
                baseData.firstDayOfMonth = this.dayOfMonth;
                break;
            case 'bimonthly':
                baseData.firstDayOfMonth = this.dayOfMonth;
                baseData.secondDayOfMonth = this.secondDayOfMonth;
                break;
        }
        this.dcaData = baseData;
    }
    setFields(data) {
        this.manualAmount = data.amount;
        this.selectedAmount = data.amount;
        this.startDate = data.startDate;
        this.frequencyValue = data.frequency;
        this.frequency = this.translateObjectPipe.transform(this.frequencyOptions.find(f => f.value === this.frequencyValue).key);
        this.dayOfWeekValue = data.dayOfWeek;
        if (this.dayOfWeekValue) {
            this.dayOfWeek = this.translateObjectPipe.transform(this.daysOfWeekOptions.find(d => d.value === this.dayOfWeekValue).key);
        }
        this.dayOfMonth = data.firstDayOfMonth;
        this.secondDayOfMonth = data.secondDayOfMonth;
        this.selectedDate = new Date(data.startDate);
    }
    expandCurrencies() {
        if (this.data.currencies) {
            this.currenciesExpanded = !this.currenciesExpanded;
        }
    }
    fillCurrency(value) {
        this.currency = value;
    }
};
InitiateDcaComponent.ctorParameters = () => [
    { type: DomSanitizer },
    { type: LocationStrategy },
    { type: WebsiteThemeService },
    { type: ChangeDetectorRef },
    { type: DatePipe },
    { type: TranslateObjectPipe },
    { type: ComponentService },
    { type: WebClientService }
];
InitiateDcaComponent = InitiateDcaComponent_1 = __decorate([
    Component({
        selector: 'app-initiate-dca',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./initiate-dca.component.html")).default,
        providers: [DatePipe, TranslateObjectPipe],
    })
], InitiateDcaComponent);
export { InitiateDcaComponent };
